import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import AppHeader from './AppHeader';

class OnlinePay extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        LOADING: true, 
        orderTOTAL: 0,
        cusNAME: '',
        cusEMAIL: '',
        cusPHONE: '',
        cusADDRESS: '',
        payment_amount: 0,
        refund_id: 0,
        ORDER_STATUS: '',
        currency: 'INR',
        bookingid: localStorage.getItem('bookingCode'),
        customer: localStorage.getItem('userData'),
      };
  
      this.paymentHandler = this.paymentHandler.bind(this);
      this.refundHandler = this.refundHandler.bind(this);
    }

    fetchCustomerOrders(mode,customer,order_id) {
      const posturl = global.config.bURL+"getBooking.php";
      const postData = {
        method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({mode: mode, bookingid: this.state.bookingid, customerid:this.state.customer})
      }
      
      fetch(posturl, postData)
        .then(res => res.json())
        .then(result => {
          // console.log('results obtained', result);
      
          let notify = '';
          if(result.err!=='' && result.err!==undefined)
              notify = result.err;
      
          this.setState({ 
            orderTOTAL:result.total, 
            cusNAME:result.NAME, 
            cusEMAIL:result.EMAIL, 
            cusPHONE:result.MOBILE,
          });

          if(result.total!=0)
            this.paymentHandler();
      
          if(notify!=='') {
              window.$('#ModalAlert').modal('show');
          }
        })
        .catch(error => {
              this.setState({ Notifications: error.toString() });
              console.error('There was an error!', error);
          });
    } 
    
    componentWillMount() {
      let customer = '';

      if(localStorage.getItem('userData'))
          customer = localStorage.getItem('userData');

      this.fetchCustomerOrders('GET_DETAILS',customer,this.state.bookingid);
    }

    UpdateCustomerOrders2(order_id, a, b) {
      b = b * 100;
      let mode = 'UPDATE';
      let customer = '';
      if(localStorage.getItem('userData'))
          customer = localStorage.getItem('userData');

      const posturl = global.config.bURL+"getBooking.php";
      const postData = {
        method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({mode: 'UPDATE', customerid:customer, bookingid: order_id, a:a, b:b, currency: this.state.currency})
      }
      
      fetch(posturl, postData)
        .then(res => res.json())
        .then(result => {
          // console.log('results obtained', result);
      
          let notify = '';
          if(result.err!=='' && result.err!==undefined)
              notify = result.err;

          let orderSTATUS = 'FAILURE';
          let ag = result.status;
          if(ag=='captured')
          {
            orderSTATUS = 'SUCCESS';
          }
          else if(ag=='authorized')
          {
            orderSTATUS = 'SUCCESS';
          }

          localStorage.setItem('payStatus', orderSTATUS); // setting order status;

          this.setState({ 
            LOADING:false, 
            ORDER_STATUS:orderSTATUS
          });
      
          if(notify!=='') {
              window.$('#ModalAlert').modal('show');
          }
        })
        .catch(error => {
              this.setState({ Notifications: error.toString() });
              console.error('There was an error!', error);
          });
    } 
    
    paymentHandler = () => {
      const payment_amount = this.state.orderTOTAL;
      const self = this;
      const options = 
      {
        key: global.config.RZ_LIVE_KEY,
        receipt: this.state.bookingid,
        amount: payment_amount*100,
        name: 'Amanora Order Id: '+this.state.bookingid,
        description: 'Order Payment for Order Id: '+this.state.bookingid,
        currency: this.state.currency,
  
        handler(response) {
          // // console.log(response);
          
          const paymentId = response.razorpay_payment_id;
          self.UpdateCustomerOrders2(self.state.bookingid, paymentId,payment_amount);


          const url = global.config.bURL+'v1/rzp_capture/'+paymentId+'/'+payment_amount;
          //const url = 'http://localhost:3000/api/v1/rzp_capture/'+paymentId+'/'+payment_amount;
          // // console.log(url);
          
          // Using my server endpoints to capture the payment
        },
  
        prefill: {
          name: this.state.cusNAME,
          email: this.state.cusEMAIL,
          contact: this.state.cusPHONE,
        },
        notes: {
          address: this.state.cusADDRESS,
        }
      };
      const rzp1 = new window.Razorpay(options);
  
      rzp1.open();
    }
  
    refundHandler(e) {
      e.preventDefault();
      const { refund_id } = this.state;
      const url = global.config.bURL+'/api/v1/rzp_refunds/'+refund_id;
  
      // Using my server endpoints to initiate the refund
      fetch(url, {
        method: 'get',
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      })
      .then(resp =>  resp.json())
      .then(function (data) {
        // // console.log('Request succeeded with JSON response', data);
        alert("Refund Succeeded", )
      })
      .catch(function (error) {
        // // console.log('Request failed', error);
      });
  
    }

    cancelPayment = () => {
      this.setState({
        ORDER_STATUS: 'FAILURE'
      })

      localStorage.setItem('payStatus', 'FAILURE'); // setting order status;
    }

    render() {

      let AppHeaderClass = 'appHeader no-border bg-coach-header text-light pt-2 pb-2';
      let AppHeaderLeft = '';
      let AppHeaderLeftLink = '';
      let AppHeaderTitle = 'Pay Now';
      let AppHeaderRight = '';
      let AppHeaderRightLink = '';
    
      if(this.state.ORDER_STATUS == 'SUCCESS')
      {
        return (<Redirect to={'/paymentresponse'} />)
      }
    
      if(this.state.ORDER_STATUS == 'FAILURE')
      {
        return (<Redirect to='/paymentresponse' />)
      }

      return (
        <div>
            <AppHeader AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} />
            <div id="appCapsule">
              <div>
                <br />
                <br />
                <br />
                <div className="row">
                  <div className="col-2"></div>
                  <div className="col-8 align-content-center">
                    <center>
                      <h4>Please do not refresh or click the back button.</h4>
                      <br />
                      <button className="btn btn-outline-primary" type="button" disabled="">
                        <span className="spinner-border spinner-border-sm mr-05" role="status" aria-hidden="true"></span>
                        Loading...
                      </button>
                      <br />
                      <br />
                      <button type="button" onClick={this.cancelPayment} className="btn btn-outline-secondary">Cancel Payment</button>
                    </center>
                  </div>
                  <div className="col-2"></div>
                </div>
              </div>
            </div>
        </div>
    );
    }
  }
  
export default OnlinePay;